'use strict';

jQuery(document).ready(function ($) {
	$('.delete-user').click(function (e) {
		e.preventDefault();

		if (!confirm('Delete user?')) {
			return false;
		}

		var link = $(this);
		var data = {
			'action': 'delete_recruiter',
			'user_id': link.data('id'),
			'nonce': ajax_object.nonce
		};

		$('.preloader').show();

		jQuery.post(ajax_object.ajax_url, data, function (response) {
			$('.preloader').hide();
			link.closest('tr').remove();
		});

		return false;
	});

	$("#recruiter-login-btn").click(function (e) {
		e.preventDefault();

		$(this).hide();

		$("#recruiter-login-block").show();
	});
});